package com.eladfinish.bible.contest.common.random

import kotlin.random.Random

class KotlinRandomProvider : RandomProvider {

    private val random: Random = Random.Default

    override fun nextInt(until: Int): Int = random.nextInt(until)
}
